<template>
  <div class="container-custom" v-if="subcategory !== null">
    <!-- breadcrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'SubCategories',
          to: {
            name: 'SubCategories'
          }
        },
        {
          name: 'SubCategory Info',
          to: {
            name: 'SubCategoryInfo',
            params: {
              id: $route.params.id
            }
          }
        },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>{{ subcategory.name }}</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="editHandler">
        <v-icon class="mr-2">edit</v-icon>
        <span>編輯</span>
      </button>
      <button class="btn" @click="deleteHandler">
        <v-icon class="mr-2">delete</v-icon>
        <span>刪除</span>
      </button>
    </div>

    <!-- block -->
    <div class="block mb-5">
      <!-- SubCategory Name -->
      <label class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">SubCategory Name</h4>
        <div>
          {{ subcategory.name }}
        </div>
      </label>
      <!-- Category -->
      <div class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">Category</h4>
        <div class="w-248px">
          {{ subcategory.product_category.name }}
        </div>
      </div>
      <!-- ID -->
      <label class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">ID</h4>
        <div class="d-flex">
          {{ subcategory.id }}
        </div>
      </label>
      <!-- Order -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4 class="mb-10px">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="w-248px">
          {{ subcategory.order }}
        </div>
      </label>
      <!-- 顯示/隱藏 -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4>顯示/隱藏</h4>
        </div>
        <div>
          {{ subcategory.status? '顯示' : '隱藏' }}
        </div>
      </label>
    </div>

    <!-- PageMenu -->
    <div class="block">
      <PageMenu :sections="sections">
        <component :is="sectionView"></component>
      </PageMenu>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PageMenu from '@/components/PageMenu.vue';
import TabSpec from '@/views/C-2__SubCategory/c/C-2-1-1__SubCategoryInfo_Tab-Spec.vue';
import TabFilter from '@/views/C-2__SubCategory/c/C-2-1-2__SubCategoryInfo_Tab-Filter.vue';
import MessagingHighlight from '@/views/C-2__SubCategory/c/C-2-1-3__SubCategoryInfo_Tab-Messaging&Highlight.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    PageMenu,
    TabSpec,
    TabFilter,
    MessagingHighlight,
    Breadscrumbs,
  },
  data: () => ({
    sections: [
      { name: 'Spec', component: 'TabSpec' },
      { name: 'Filter', component: 'TabFilter' },
      // { name: 'Messaging & Highlight', component: 'MessagingHighlight' },
    ],
  }),
  async created() {
    if (this.$route.params.id) {
      await this.getSubCategory(this.$route.params.id);
    }
  },
  computed: {
    ...mapState('subcategory', ['subcategory']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  methods: {
    ...mapActions('subcategory', {
      getSubCategory: 'findById',
      destroySubCategory: 'destroy',
    }),
    editHandler() {
      this.$router.push({
        name: 'SubCategoryInfoEdit',
        params: {
          id: this.$route.params.id,
        },
      });
    },
    async deleteHandler() {
      await this.destroySubCategory(this.subcategory.id).then(() => {
        this.$router.push({ name: 'SubCategories' });
      });
    },
  },
};
</script>
